import { SubmissionStatus } from "generated-graphql/graphql";

/**
 * Whether the viewer is a reviewer who must acknowledge Understand before
 * reviewing. Staff are exempt (shared progress, not a personal acknowledgment),
 * and a frozen submission has nothing left to review.
 */
export function needsUnderstandAcknowledgment({
  isStaff,
  isFrozen,
  status,
  reviewer,
}: {
  isStaff: boolean;
  isFrozen: boolean;
  status?: SubmissionStatus | null;
  reviewer?: { acknowledgedAt?: string | null } | null;
}) {
  const inReviewOrSigning =
    status === SubmissionStatus.EncampInitialReview || status === SubmissionStatus.InReview;
  return inReviewOrSigning && !isFrozen && !isStaff && !!reviewer && !reviewer.acknowledgedAt;
}
